import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { DataGrid } from '@material-ui/data-grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import ButtonHeader from '../components/ButtonHeader.jsx';
import CardFormatsTab from '../components/CardFormatsTab.jsx';

const columns = [
  { field: 'cardformat', headerName: 'Card Format', width: 200 },
  { field: 'active', headerName: 'Active', width: 200 },
  {
    field: 'facilitycode',
    headerName: 'Facility Code',
    width: 196,
  },
];

const emptyFormValue = {
  active: '',
  cardformat: '',
  facilitycode: '',
  id: '',
  cardFormatValue: '',
  formatOptions: [
    { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
    { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
    { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
    { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
    { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
    { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
    { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
    { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
    { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
    { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
    { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
    { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
  ],
  cardOptions: [
    { id: 'parity', labelName: 'Parity', checked: false },
    { id: 'suppress', labelName: 'Suppress', checked: false },
    { id: 'corporate', labelName: 'Corporate', checked: false },
    { id: 'parity374', labelName: 'Parity 374', checked: false },
    { id: 'parity372', labelName: 'Parity 372', checked: false },
    { id: '48bitformat', labelName: '48 Bit Format', checked: false },
  ],
  idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
};

const rows = [
  {
    id: 1,
    cardformat: 'Standard 26 bit',
    active: 'Yes',
    facilitycode: 35,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 26 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 13 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 13 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 13 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 8 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 1 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 16 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 9 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 2,
    cardformat: 'HID Corporate 1000 35 bit',
    active: 'No',
    facilitycode: 42,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 35 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 12 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 2 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 20 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 14 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 3,
    cardformat: 'IDenticard 37 bit',
    active: 'No',
    facilitycode: 45,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 37 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 13 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 6 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 17 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 19 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 4,
    cardformat: 'HID 37 bit',
    active: 'Yes',
    facilitycode: 16,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 37 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 16 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 1 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 19 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 17 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 5,
    cardformat: 'MiFare CSN',
    active: 'No',
    facilitycode: 10,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 6,
    cardformat: 'iClass CSN',
    active: 'No',
    facilitycode: 150,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 7,
    cardformat: 'Dorado 34 bit',
    active: 'Yes',
    facilitycode: 44,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 34 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 16 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 1 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 16 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 17 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 8,
    cardformat: 'H10313Q(HID) - Joined ',
    active: 'Yes',
    facilitycode: 36,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 9,
    cardformat: '40 bit XceedID Cardtrax',
    active: 'No',
    facilitycode: 65,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 10,
    cardformat: '40 bit CSN',
    active: 'No',
    facilitycode: 150,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 11,
    cardformat: 'RBH50 - 32/16',
    active: 'Yes',
    facilitycode: 44,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 12,
    cardformat: 'Kastle 32 bit',
    active: 'Yes',
    facilitycode: 36,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 13,
    cardformat: '64 bit CSN',
    active: 'No',
    facilitycode: 65,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 14,
    cardformat: 'HID 37 bit (No Site Code)',
    active: 'No',
    facilitycode: 150,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 0 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 0 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 0 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 0 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 0 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },

  {
    id: 15,
    cardformat: 'AWID 34 bit',
    active: 'No',
    facilitycode: 20,
    cardFormatValue: 'wiegand',
    formatOptions: [
      { id: 'facilitycode', labelName: 'Facility Code', value: 0 },
      { id: 'bitsoncard', labelName: 'Bits on Card', value: 34 },
      { id: 'parityevenlength', labelName: 'Parity Even Length', value: 0 },
      { id: 'parityevenstart', labelName: 'Parity Even Start', value: 0 },
      { id: 'parityoddlength', labelName: 'Parity Odd Length', value: 0 },
      { id: 'parityoddstart', labelName: 'Parity Odd Start', value: 0 },
      { id: 'facilitycodelength', labelName: 'Facility Code Length', value: 8 },
      { id: 'facilitycodestart', labelName: 'Facility Code Start', value: 1 },
      { id: 'cardholderidlength', labelName: 'Cardholder ID Length', value: 24 },
      { id: 'cardholderidstart', labelName: 'Cardholder ID Start', value: 9 },
      { id: 'issuecodelength', labelName: 'Issue Code Length', value: 0 },
      { id: 'issuecodestart', labelName: 'Issue Code Start', value: 0 },
    ],
    cardOptions: [
      { id: 'parity', labelName: 'Parity', checked: false },
      { id: 'suppress', labelName: 'Suppress', checked: false },
      { id: 'corporate', labelName: 'Corporate', checked: false },
      { id: 'parity374', labelName: 'Parity 374', checked: false },
      { id: 'parity372', labelName: 'Parity 372', checked: false },
      { id: '48bitformat', labelName: '48 Bit Format', checked: false },
    ],
    idoffset: [{ id: 'idoffset', labelName: 'ID Offset', value: 0 }],
  },
];

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    minHeight: '600px',
  },
  headerName: {
    fontWeight: 'bold',
  },
  icon: {
    position: 'absolute',
    right: '-40px',
  },
  infoIcon: {
    fontSize: 'large',
  },
  activeCheck: {
    float: 'left',
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.8),
    [`& span`]: {
      fontSize: 'inherit',
    },
  },
  defaultCheck: {
    float: 'right',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.8),
    [`& span`]: {
      fontSize: 'inherit',
    },
  },
  fullWidth: {
    width: '100%',
  },
  withMargins: {
    margin: theme.spacing(1),
    minWidth: 120,
    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
  cardFormatField: {
    margin: theme.spacing(1),
    maxWidth: '98%',
    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
  card: {
    margin: theme.spacing(4),
  },
  listItemText: {
    marginRight: theme.spacing(1),
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  gridWrapper: {
    width: '50%',
    cursor: 'pointer',
  },
  editCardFormatWrapper: {
    width: '50%',
    padding: theme.spacing(5),
  },
}));

function CardFormats() {
  const classes = useStyles();
  const [row, setRow] = useState(emptyFormValue);
  const handleRowClick = (data) => {
    setRow(data.row);
  };
  return (
    <>
      <ButtonHeader title="Card Format(s)" />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/admin">
          Administration
        </Link>
        <Link color="inherit" href="/globalSettings/globalSetting">
          Global Settings
        </Link>
        <Typography color="textPrimary">Card Format(s)</Typography>
      </Breadcrumbs>
      <br />
      <div className={classes.root}>
        <Paper className={classes.content}>
          <div className={classes.gridWrapper}>
            <DataGrid
              rowsPerPageOptions={[15, 30, 45]}
              pagination
              rows={rows}
              onRowClick={handleRowClick}
              className="cardFormatGrid"
              columns={columns}
              pageSize={15}
            />
          </div>
          <div className={classes.editCardFormatWrapper}>
            <Typography variant="subtitle2">
              Select a card format in the table to the left to edit. Otherwise use the form below to
              create a new one.
            </Typography>
            <div>
              <FormControlLabel
                className={classes.activeCheck}
                value=""
                checked={!!(row && row.active === 'Yes')}
                control={<Checkbox color="secondary" />}
                label="Active"
                labelPlacement="end"
              />
              <FormControlLabel
                className={classes.defaultCheck}
                value=""
                x
                checked={!(row && row.active !== 'No')}
                control={<Checkbox color="secondary" />}
                label="Default"
                labelPlacement="end"
              />
              <FormControl className={classes.fullWidth}>
                <TextField
                  size="small"
                  className={classes.withMargins}
                  value={row && row.cardformat}
                  label="Name"
                  variant="outlined"
                  required
                />
              </FormControl>

              <FormControl className={classes.fullWidth}>
                <TextField
                  size="small"
                  className={classes.withMargins}
                  value={row && row.cardformat}
                  label="Description"
                  variant="outlined"
                />
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.cardFormatField}
                size="small"
                fullWidth
              >
                <InputLabel>Card Format</InputLabel>
                <Select native value={row && row.cardFormatValue} label="Card Format">
                  <option value=""></option>
                  <option value="wiegand">Wiegand</option>
                  <option value="aba">ABA</option>
                  <option value="mta">MTA</option>
                  <option value="no">No Format</option>
                </Select>
                <Tooltip title="Info">
                  <IconButton aria-label="info" className={classes.icon} color="secondary">
                    <InfoOutlinedIcon className={classes.infoIcon} />
                  </IconButton>
                </Tooltip>
              </FormControl>
            </div>
            <br />
            <CardFormatsTab formatTabDetails={row} />
          </div>
        </Paper>
      </div>
    </>
  );
}

export default CardFormats;
